import { Injectable } from '@angular/core';
import { NgbTimeAdapter, NgbTimeStruct } from '@cmps/ng-bootstrap';
import { isValid } from 'date-fns';

@Injectable()
export class TimeNativeAdapter extends NgbTimeAdapter<Date> {
    fromModel(value: Date | null): NgbTimeStruct | null {
        if (!isValid(value)) {
            return null;
        }
        return {
            hour: value.getHours(),
            minute: value.getMinutes(),
            second: value.getSeconds(),
        };
    }

    toModel(time: NgbTimeStruct | null): Date | null {
        if (time == null) {
            return null;
        }
        const date = new Date();
        return new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            time.hour,
            time.minute,
            time.second,
        );
    }
}
